import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from "react-select";
import PoPrintModal from './PoPrintModal';
import PoServices from "../../../services/PoServices";
import Spinner from 'react-bootstrap/Spinner';
import ReceivedOrderModal from './ReceivedOrderModal';
import BillingViewModal from './BillingViewModal';
import * as XLSX from "xlsx";


const PendingBilling = () => {
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(true);
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [gridInsideModal, setGridInsideModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [sort, setSort] = useState(20);
    const [searchTerm, setSearchTerm] = useState("");
    const [gridInsideModal2, setGridInsideModal2] = useState(false);
    const [selectedItem2, setSelectedItem2] = useState(null);
    const [gridInsideModal3, setGridInsideModal3] = useState(false);
    const [selectedItem3, setSelectedItem3] = useState(null);
    const activePag = useRef(0);
    const [test, setTest] = useState(0);
    const [printModalOpen, setPrintModalOpen] = useState(false);
    const [printPoData, setPrintPoData] = useState(null);
    const [loading, setLoading] = useState(true);



    const options = [
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 20, label: '20' },
        { value: 50, label: '50' },
        { value: 100, label: '100' }
    ];

    useEffect(() => {
        const fetchPurchaseOrders = async () => {
            try {
                setLoading(true); // Start loader

                // ✅ Fetch only 'Generated' purchase orders
                const res = await PoServices.AllPOByStatus("start");
                const poList = res?.data || [];
                setPurchaseOrders(poList);
            } catch (error) {
                console.error(error);
                Swal.fire("Error", "Failed to fetch purchase orders", "error");
            } finally {
                setLoading(false); // Stop loader
            }
        };

        fetchPurchaseOrders();
    }, [test]); // Optional: use dependency if needed



    const filteredSearch = purchaseOrders.filter(po => {
        const requisitionNumber = String(po?.requisitionNo?.requisitionNo || "");
        const poNumber = String(po?.poNumber || "");
        const supplierName = String(po?.items?.[0]?.supplier?.name || "").toLowerCase();
        const createdBy = String(po?.createdBy?.name || "").toLowerCase();
        const storeLocation = String(po?.requisitionNo?.store?.name || "").toLowerCase();
        const partNo = String(po?.items?.[0]?.partNo || "").toLowerCase();
        const descriptionSearch = String(po?.items?.[0]?.description || "").toLowerCase();

        const search = searchTerm.toLowerCase();

        return (
            requisitionNumber.includes(search) ||
            poNumber.includes(search) ||
            supplierName.includes(search) ||
            createdBy.includes(search) ||
            storeLocation.includes(search) ||
            partNo.includes(search) ||
            descriptionSearch.includes(search)
        );
    });


    const pagination = Math.ceil(filteredSearch.length / sort);

    const onClick = (i) => {
        activePag.current = i;
        setTest(i);
    };

    const handleViewClick = (poDetails) => {
        setSelectedItem(poDetails);       // set item to pass into modal
        setGridInsideModal(true);         // show modal
    };



    const handleViewItem = (e, row) => {
        e.stopPropagation(); // prevent bubbling if inside clickable row
        setSelectedItem2(row);
        setGridInsideModal2(true);
    };

    const handleBillingView = (e, row) => {
        e.stopPropagation(); // prevent bubbling if inside clickable row
        setSelectedItem3(row);
        setGridInsideModal3(true);
    };

    const handleDownloadExcel = () => {
        if (!filteredSearch || filteredSearch.length === 0) return;

        // 1. Flatten the data
        const flattenedData = [];
        filteredSearch.forEach((row, index) => {
            const poNo = row?.poNumber || "N/A";
            const requisitionNo = row?.requisitionNo?.requisitionNo || row?.requisitionNo?._id || "N/A";
            const storeName = row?.requisitionNo?.store?.name || "N/A";
            const deliveryAddress = row?.deliveryAddress
                ? `${row.deliveryAddress.street}, ${row.deliveryAddress.city}, ${row.deliveryAddress.state} - ${row.deliveryAddress.pincode}, ${row.deliveryAddress.country}`
                : "N/A";
            const createdAt = row?.createdAt ? new Date(row.createdAt).toLocaleDateString("en-IN") : "N/A";

            if (row.items && row.items.length > 0) {
                row.items.forEach((item) => {
                    flattenedData.push({
                        "#": index + 1,
                        Requisition: requisitionNo,
                        PO: poNo,
                        "Part No": item?.partNo || "N/A",
                        Description: item?.description || "N/A",
                        Qty: item?.approveQty || "N/A",
                        Rate: item?.rate || "N/A",
                        Store: storeName,
                        Supplier: item?.supplier?.name || "N/A",
                        "Delivery Address": deliveryAddress,
                        CreatedAt: createdAt,
                    });
                });
            } else {
                // if no items, still include the row
                flattenedData.push({
                    "#": index + 1,
                    Requisition: requisitionNo,
                    PO: poNo,
                    "Part No": "N/A",
                    Description: "N/A",
                    Qty: "N/A",
                    Rate: "N/A",
                    Store: storeName,
                    Supplier: "N/A",
                    "Delivery Address": deliveryAddress,
                    CreatedAt: createdAt,
                });
            }
        });

        // 2. Convert to worksheet
        const worksheet = XLSX.utils.json_to_sheet(flattenedData);

        // 3. Create workbook and append worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Orders");

        // 4. Trigger download on client-side
        XLSX.writeFile(workbook, "PurchaseOrders.xlsx");
    };



    return (
        loading ? (
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner animation="border" role="status" variant="primary" />
                <p className="mt-2 fw-bold text-primary">Loading PO...</p>
            </div>
        ) : (
            <>
                {selectedItem2 && (
                    <ReceivedOrderModal
                        show={gridInsideModal2}
                        handleClose={() => setGridInsideModal2(false)}
                        test={setTest}
                        admin={selectedItem2}
                    />
                )}

                {selectedItem3 && (
                    <BillingViewModal
                        show={gridInsideModal3}
                        handleClose={() => setGridInsideModal3(false)}
                        test={setTest}
                        admin={selectedItem3}
                    />
                )}

                <PoPrintModal
                    show={gridInsideModal}
                    onHide={() => setGridInsideModal(false)}
                    item={selectedItem}
                />
                <div className="row">
                    <div className="col-xl-12">

                        {/* Filter */}
                        <div className="filter cm-content-box box-primary">
                            <div className="content-title">
                                <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
                                <div className="tools">
                                    <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                                        <i className="fas fa-angle-up"></i>
                                    </Link>
                                </div>
                            </div>
                            <Collapse in={open}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-xl-3 col-xxl-6 mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by Requisition No., Po Number, Supplier Name, Store"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-xl-3 col-xxl-6 mb-3">
                                                <Select
                                                    placeholder="Rows per page"
                                                    value={options.find(option => option.value === sort)}
                                                    onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                                                    isSearchable={false}
                                                    options={options}
                                                    className="custom-react-select"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        {/* Table */}
                        <div className="filter cm-content-box box-primary">
                            {/* Table Header: Title + Download */}
                            <div className="content-title d-flex justify-content-between align-items-center">
                                <div className="cpa">
                                    <i className="fa fa-list me-2"></i>Pending Purchase Orders For Billing
                                    <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                    {/* Download Button */}
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={handleDownloadExcel}
                                        style={{ height: "35px", display: "flex", alignItems: "center" }}
                                    >
                                        <i className="fa fa-download me-1"></i> Download Excel
                                    </button>

                                    {/* Collapse toggle */}
                                    <Link
                                        to="#"
                                        className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                        onClick={() => setOpen2(!open2)}
                                        style={{ marginLeft: "10px" }}
                                    >
                                        <i className="fas fa-angle-up"></i>
                                    </Link>
                                </div>
                            </div>


                            <Collapse in={open2}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div id="content_wrapper" className="dataTables_wrapper no-footer">
                                                <div style={{
                                                    overflowX: 'auto',
                                                    overflowY: 'auto',
                                                    maxHeight: '400px',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                                                        <thead
                                                            style={{
                                                                position: "sticky",
                                                                top: 0,
                                                                backgroundColor: "#fff", // White background
                                                                zIndex: 2,
                                                            }}
                                                        >
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Requisition</th>
                                                                <th>Po</th>
                                                                <th>Part No</th>
                                                                <th>Description</th>
                                                                <th>Qty</th>
                                                                <th>Rate</th>
                                                                <th>Store</th>
                                                                <th>Suppplier</th>
                                                                <th>Deliver Address</th>
                                                                <th>CreatedAt</th>
                                                                <th>Items</th>
                                                                <th>View Items</th>
                                                                <th>Print</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {filteredSearch.length > 0 ? (
                                                                filteredSearch
                                                                    .slice(activePag.current * sort, (activePag.current + 1) * sort)
                                                                    .map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td>{activePag.current * sort + index + 1}</td>
                                                                            <td>{row?.requisitionNo?.requisitionNo || row?.requisitionNo?._id || 'N/A'}</td>
                                                                            <td>{row?.poNumber || 'N/A'}</td>
                                                                            <td>
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>{item?.partNo || 'N/A'}</div>
                                                                                ))}
                                                                            </td>
                                                                            <td className="scrollable-description">
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>{item?.description || 'N/A'}</div>
                                                                                ))}
                                                                            </td>
                                                                            <td>
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>{item?.approveQty || 'N/A'}</div>
                                                                                ))}
                                                                            </td>
                                                                            <td>
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>{item?.rate || 'N/A'}</div>
                                                                                ))}
                                                                            </td>
                                                                            <td className="scrollable-description">{row?.requisitionNo?.store?.name}</td>
                                                                            <td className="scrollable-description">
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>{item?.supplier?.name || 'N/A'}</div>
                                                                                ))}
                                                                            </td>
                                                                            <td className="scrollable-description">
                                                                                {row?.deliveryAddress?.street}, {row?.deliveryAddress?.city},<br />
                                                                                {row?.deliveryAddress?.state} - {row?.deliveryAddress?.pincode},<br />
                                                                                {row?.deliveryAddress?.country}
                                                                            </td>
                                                                            <td>{new Date(row?.createdAt).toLocaleDateString('en-IN')}</td>
                                                                            <td>{row?.items?.length || 0}</td>
                                                                            <td><i className="fa fa-eye" onClick={(e) => { handleViewItem(e, row) }}></i>
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    className="btn btn-success btn-xs"
                                                                                    onClick={() => handleViewClick(row)}
                                                                                >
                                                                                    Print{/*row?.items?.[0]?.supplier?.name || "Unknown Supplier"*/}
                                                                                </button>
                                                                            </td>
                                                                            <td>
                                                                                <div className="d-flex gap-2 justify-content-center">
                                                                                    <button
                                                                                        className="btn btn-success d-flex flex-column align-items-center justify-content-center py-1 px-2"
                                                                                        style={{ width: "60px", borderRadius: "8px", height: "55px" }}
                                                                                        onClick={(e) => { handleBillingView(e, row) }}

                                                                                    >
                                                                                        <i className="fa-solid fa-check text-white fs-5 mb-1"></i>
                                                                                        <span className="text-white" style={{ fontSize: '10px' }}>Approve</span>
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn btn-warning d-flex flex-column align-items-center justify-content-center py-1 px-2"
                                                                                        style={{ width: "60px", borderRadius: "8px", height: "55px" }}

                                                                                    >
                                                                                        <i className="fa-solid fa-rotate-left text-white fs-5 mb-1"></i>

                                                                                        <span className="text-white" style={{ fontSize: '10px' }}>Store Admin</span>
                                                                                    </button>
                                                                                </div>
                                                                            </td>

                                                                        </tr>
                                                                    ))
                                                            ) : (
                                                                <tr><td colSpan="13" className="text-center">No Purchase Orders Found</td></tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Pagination */}
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <div className="dataTables_info">
                                                        Showing {filteredSearch.length > 0 ? (activePag.current * sort + 1) : 0} to{" "}
                                                        {Math.min(filteredSearch.length, (activePag.current + 1) * sort)} of {filteredSearch.length} entries
                                                    </div>
                                                    <div className="dataTables_paginate paging_simple_numbers">
                                                        <Link className="paginate_button previous" to="#" onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}>
                                                            <i className="fa fa-angle-double-left"></i>
                                                        </Link>
                                                        <span>
                                                            {Array.from({ length: pagination }, (_, i) => (
                                                                <Link
                                                                    key={i}
                                                                    to="#"
                                                                    className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                                                    onClick={() => onClick(i)}
                                                                >
                                                                    {i + 1}
                                                                </Link>
                                                            ))}
                                                        </span>
                                                        <Link className="paginate_button next" to="#" onClick={() => activePag.current < pagination - 1 && onClick(activePag.current + 1)}>
                                                            <i className="fa fa-angle-double-right"></i>
                                                        </Link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                </div>
            </>
        )
    );
};

export default PendingBilling;
